import { render, staticRenderFns } from "./ShipperEdit.vue?vue&type=template&id=9a01a740&"
import script from "./ShipperEdit.vue?vue&type=script&lang=js&"
export * from "./ShipperEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports